<template>
	<div>
		<div class="banner">
		</div>
		
		<div class="made">
			<div>
				<span class="quick">现在咨询立即获得</span>
				<span class="free">免费资料</span>
			</div>

			<div class="all">
				<div class="line"></div>
				<div class="now">目前已经有 <span>{{count}} </span>人获取结果</div>
				<div class="line"></div>
			</div>
		</div>
		

		<form action="" ref="formData" class="form" id="formInput">
			<div class="u-item">
				<input type="text" class="input" v-model="formData.name" placeholder="姓名">
			</div>

			<div class="u-item">
				<input type="tel" v-validate="'required|isMobile'" data-vv-name="手机号码" :class="colorShow?'input':'input yellow-border'" v-model="formData.mobile" ref="mobileInput" @blur="mobileBlur" placeholder="手机号码">
			</div>
			<div class="u-item">
				<!--<div class="name">验证码</div>-->
				<div class="clearfix" style="height: 45px;line-height: 56px;width: 100%;">
					<input type="tel" :class="codeInputCode1?'input':'input yellow-border'" style="float:left;width:55%;" v-validate="'required'" data-vv-name="验证码" placeholder="验证码" v-model="mobileCode1" ref="codeInput1">
					<span class="float:right;" @click="getCode">{{ verificationCode1 }}</span>
				</div>
			</div>
			<div class="submit" @click="saveAllInfo">免费获取6800元试听课</div>
		</form>
        <div>
        	<img src="../../img/6.jpg" style='width:100%' />
        </div>
        
        <div>
        	<img src="../../img/7.jpg" style='width:100%;margin-top:-8px' />
        </div>
        
        <div>
        	<img src="../../img/8.jpg" style='width:100%;margin-top:-8px' />
        </div>
        
        <div>
        	<img src="../../img/9.jpg" style='width:100%;margin-top:-8px' />
        </div>
		<form action="" class="form">
			<div class="u-item">
				<input type="tel" :class="secondColorShow?'input':'input yellow-border'" v-model="secondMobile" ref="secondMobileInput" @blur="secondMobileBlur" placeholder="手机号码">
			</div>
			<div class="u-item clearfix" style="height: 45px;line-height: 56px;">
				<input type="tel" :class="codeInputCode2?'input':'input yellow-border'" style="float:left;width:55%;" placeholder="验证码" v-model="mobileCode2" ref="codeInput2">
				<span class="float:right;" @click="getCode2">{{ verificationCode2 }}</span>
			</div>
			<div class="submit" @click="secondSaveAllInfo">立即提交</div>
		</form>
	</div>
</template>

<script>
	import { getInsert, getCountList, advertisersCallback, getCodeFun, getVerifyCode } from "./apis.js";
	export default {
		name: "Index",
		data() {
			return {
				formData: {
					name: '',
					mobile: '',
					channelCode: this.$route.query.channelCode
				},
				colorShow: true,
				codeInputCode1: true,
				codeInputCode2: true,
				secondColorShow: true,
				secondMobile: '',
				count:'',
				status: true,
				secondStatus:true,
				timer: 60,
				verificationCode1: "获取验证码",
				verificationCode2: "获取验证码",
				codeFocus:false,
				mobileCode: '' ,//短信验证码
				mobileCode1: '' ,//短信验证码
				mobileCode2: '' ,//短信验证码
				mobile: '' //手机号
				
			};
		},
		methods: {
			getCode() {	
				if(this.formData.mobile == ""){
					this.$layer.msg("手机号码不能为空", {time: 3});
					this.$refs.mobileInput.focus();
				}else{
					if(this.errors.items.length != 0 && this.errors.items[0].field == "手机号码") {
						this.$layer.msg(this.errors.items[0].msg, {time: 3});
						this.$refs.mobileInput.focus();
						this.colorShow = false;
						return;
					}
					if(this.status) {	
						this.status = false;
						var count = this.timer;
						this.verificationCode1 = count + "s后重新获取";
						var timer = setInterval(() => {
							if(count === 0) {
								clearInterval(timer);
								this.verificationCode1 = "获取验证码";
								this.status = true;
							} else {
								count--;
								this.verificationCode1 = count + "s后重新获取";
							}
						}, 1000);
						this.mobile = this.formData.mobile;
						this.$refs.codeInput1.focus();
						this.getSmsCode();
					}
				}
			},
			getCode2() {	//第二个获取验证码
				if(this.secondMobile == ""){
					this.$layer.msg(`手机号码不能为空`, {time: 3});
					this.$refs.secondMobileInput.focus();
					this.secondColorShow = false;
					return
				}
				if(!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.secondMobile))){
					this.$layer.msg("手机号码格式不正确", {time: 3});
					this.$refs.secondMobileInput.focus();
					this.secondColorShow = false;
					return;
				}else{
					if(this.secondStatus) {	
						this.secondStatus = false;
						var count = this.timer;
						this.verificationCode2 = count + "s后重新获取";
						var timer = setInterval(() => {
							if(count === 0) {
								clearInterval(timer);
								this.verificationCode2 = "获取验证码";
								this.secondStatus = true;
							} else {
								count--;
								this.verificationCode2 = count + "s后重新获取";
							}
						}, 1000);
						this.mobile = this.secondMobile;
						this.$refs.codeInput2.focus();
						this.getSmsCode();
					}
				}
			},
			async getSmsCode(){//获取验证码
				try {
					let param = {
						"mobile": this.mobile
					}
					let {data} = await getCodeFun(param);
					if(data.code == 1000){
						this.$layer.msg(data.message, {time: 3});
					}
				} catch(err) {
					console.log(err);
				}
			},
			async getVerifyCode(){//验证短信验证码是否正确
				try {
					let param = {
						"mobile": this.mobile,
						"mobileCode": this.mobileCode
					}
					let {data} = await getVerifyCode(param);
					if(data.code == 1000){
						console.log("验证短信验证码", data);
//						this.$layer.msg(data.message, {time: 3});
						this.saveInfo();
					}else{
						this.$layer.msg(data.message, {time: 3});
					}
				} catch(err) {
					console.log(err);
				}
			},
			async saveInfo() { //保存
				try {
					if(this.formData.name == " ") {
						this.formData.name = ""
					}
					this.formData.mobile = this.mobile;
					let {data} = await getInsert(this.formData);
					if(data.code == 1000){
						console.log("保存接口返回的数据", data);
						this.$layer.msg(data.message, {time: 3});
						this.advertisersCallback();
					}else{
						this.$layer.msg(data.message, {time: 3});
						this.advertisersCallback();
					}
				} catch(err) {
					console.log(err);
				}
			},
			async advertisersCallback() { //广告回调
				try {
					let params = {
						p: this.$route.query.p
					}
					let {data} = await advertisersCallback(params);
					console.log("广告回调返回数据", data);
				} catch(err) {
					console.log(err);
				}
			},
			saveAllInfo() {
				this.$validator.validateAll().then((res) => {
					if(res) {
//						this.saveInfo();
						this.mobileCode = this.mobileCode1;
						this.getVerifyCode();
						return
					}
					if(this.errors.items[0].rule == 'required') {
						this.$layer.msg(`${this.errors.items[0].field}不能为空`, {time: 3});
						if(`${this.errors.items[0].field}` == "手机号码"){
							this.$refs.mobileInput.focus();
							this.colorShow = false;
						}
						if(`${this.errors.items[0].field}` == "验证码"){
							this.$refs.codeInput1.focus();
							this.codeInputCode1 = false;
						}
						return
					}
					if(this.errors.items.length != 0 && this.errors.items[0].field == "手机号码") {
						this.$layer.msg(this.errors.items[0].msg, {time: 3});
						this.$refs.mobileInput.focus();
						this.colorShow = false;
						return;
					}
				})
			},
			secondSaveAllInfo() {
				if(this.secondMobile == ""){
					this.$layer.msg(`手机号码不能为空`, {time: 3});
					this.$refs.secondMobileInput.focus();
					this.secondColorShow = false;
					return
				}
				if(this.mobileCode2 == ""){//验证码不能为空
					this.$layer.msg(`验证码不能为空`, {time: 3});
					this.$refs.codeInput2.focus();
					this.codeInputCode2 = false;
					return
				}
				if(!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.secondMobile))){
					this.$layer.msg("手机号码格式不正确", {time: 3});
					this.$refs.secondMobileInput.focus();
					this.secondColorShow = false;
					return;
				}else{
					this.mobile = this.secondMobile;
					this.mobileCode = this.mobileCode2;
//					this.saveInfo();
					this.getVerifyCode();
					return
				}
			},
			async getCountList(){//获取人数
				try {
					let {data} = await getCountList();
					console.log("人数",data);
					this.count = data.data;
				} catch(err) {
					console.log(err);
				}
			},
			mobileBlur() {//手机号码input失焦事件
				this.colorShow = true;
			},
			secondMobileBlur() {//手机号码input失焦事件
				this.secondColorShow = true;
			},
		},
		mounted() {
			this.getCountList();
		}
	};
</script>

<style scoped>
	.yellow-border {
		border: 1px solid #f28506!important;
	}
	
	.clearfix:after {
		content: ' ';
		display: block;
		clear: both;
		height: 0;
		visibility: hidden;
	}
	
	.banner {
		width: 100%;
		height: 500px;
		background: url("../../img/5.jpeg") no-repeat;
		background-size: 100% 100%;
	}
	
	.both {
		padding-top: 20px;
	}
	
	.img {
		width: 12%;
		display: inline-block;
		vertical-align: middle;
	}
	
	.text {
		color: #fff;
		display: inline-block;
		vertical-align: middle;
		margin-top: 2px;
	}
	
	.button div {
		width: 30%;
		height: 32px;
		background: #fff;
		display: inline-block;
		float: left;
		text-align: center;
		line-height: 32px;
		margin-left: 10px;
		opacity: 0.7;
		margin-top: 280px;
		border-radius: 12px;
		margin-bottom: 30px;
	}
	
	.made {
		width: 92%;
		background: #fff;
		height: 120px;
		clear: both;
		margin:-69px auto;
		border-radius: 6px;
		padding-top: 13px;
	}
	
	.quick {
		font-size: 20px;
		color: #3e3a39;
		font-weight: bold;
	}
	
	.free {
		font-size: 20px;
		color: #f28506;
		font-weight: bold;
	}
	
	.line {
		width: 40px;
		float: left;
		background: #e7e7e7;
		height: 2px;
		margin-top: 9px;
	}
	
	.now {
		float: left;
	}
	
	.all {
		padding: 0 40px;
		margin-top: 20px;
	}
	
	.form {
		margin-bottom: 40px;
	}
	
	.u-item {
		width: 80%;
		margin-bottom: 15px;
		margin: 0 auto;
	}
	
	.name {
		text-align: left;
		font-size: 16px;
		margin-top: 10px;
	}
	
	.input {
		width: 100%;
		height: 35px;
		border: 1px solid #c6cacc;
		margin-top: 10px;
		background: #f6fcff;
		border-radius: 6px;
		padding-left: 15px;
	}
	
	.option select {
		width: 30%;
		height: 35px;
		float: left;
		border: 1px solid #c6cacc;
		background: #f6fcff;
		border-radius: 6px;
		margin-top: 10px;
		margin-bottom: 15px;
		outline: none;
		padding-left: 15px;
		margin-right: 5%;
	}
	
	.u-trade select {
		width: 100%;
		height: 35px;
		border: 1px solid #c6cacc;
		background: #f6fcff;
		border-radius: 6px;
		margin-top: 10px;
		margin-bottom: 15px;
		outline: none;
		padding-left: 15px;
	}
	
	.submit {
		width: 90%;
		height: 40px;
		background: #f28506;
		color: #fff;
		line-height: 40px;
		text-align: center;
		margin: 20px auto;
		border-radius: 4px;
	}
	
	.footer {
		width: 100%;
		height: 150px;
		background: url("../../img/4.png") no-repeat;
		background-size: 100% 100%;
	}
	
	.bottom {
		background: #000;
		width: 100%;
		height: 54px;
		opacity: 0.6;
		position: relative;
		bottom: -96px;
		color: #fff;
		font-size: 13px;
		line-height: 20px;
		font-weight: bold;
		padding-top: 5px;
	}
	#formInput{
		clear:both;
		margin-top:40px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/sm/index2.vue